<!-- <template>
  <div
    :class="['cmp', 'cmp-header', { active: ['home'].includes($route.name) && !isHeaderFixed }]"
    :style="headerStyles"
  >
    <section class="header-section flex-center">
      <div class="cmp-header-left flex-center">
        <img src="../../assets/images/index/logo.png" @click="$router.push({ name: 'home' })" />
      </div>
      <ul class="header-menu-list flex-center">
        <li
          v-for="(item, index) in menuList"
          :key="index"
          @click="handleSelect(item)"
          v-show="(userInfo.type || 'STUDENT') === item.clientType || !item.clientType"
          :class="{ bg: activePath === item.routerName }"
        >
          {{ item.name }}
          <div v-if="item.childrens.length">
            <span v-for="(v, i) in item.childrens" @click.stop="handleSelect(v)" :key="i">
              {{ userInfo.type === "TEACHER" && v.teaName ? v.teaName : v.name }}
            </span>
          </div>
        </li>
      </ul>
   
      <div class="cmp-header-right">
        <template v-if="userInfo.token">
          <a href="javascript:;">
            <el-dropdown trigger="click" @command="commandHandler">
              <span class="el-dropdown-link">
                <i class="fa fa-user-circle-o" aria-hidden="true"></i>
                {{ userInfo.userName }}
              </span>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item command="user">用户中心</el-dropdown-item>
                  <el-dropdown-item command="logout">退出登录</el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </a>
        </template>
        <template v-else>
          <a href="javascript:;" @click="$jstools.myEvent.dispatchEvent('login-open', { flag: true })">登录</a>
        </template>
      </div>
    </section>
    <loginModal></loginModal>
  </div>
</template> -->

<template>
  <!-- type -->
  <div :class="['cmp_header', `cmp_header_${type}`]">
    <img v-if="type === 1" class="login_logo" src="@/assets/images/public/logo_.png" alt="" />
    <img v-else class="login_logo" src="@/assets/images/public/logo_bg.png" alt="" />
    <section :style="{ justifyContent: screenWidth < 1920 ? 'center' : '' }">
      <div class="nav_list">
        <template v-if="userInfo.type === 'TEACHER' && (userInfo.modules === '0' || userInfo.modules === '')">
          <section v-for="(v, i) in menuList1" :key="i">
            <p @click="handleSelect(v)" :class="{ hover: activePath === v.routerName }" v-if="v.clientType.includes(userInfo.type || 'STUDENT') || !v.clientType.length">
              {{ v.name }}
              <ul v-if="(v.childrens || []).length">
                <li v-for="(v, i) in v.childrens" @click.stop="handleSelect(v)" :key="i">
                  {{ userInfo.type === "TEACHER" && v.teaName ? v.teaName : v.name }}
                </li>
              </ul>
            </p>
          </section>
        </template>
        <template v-else>
          <section v-for="(v, i) in menuList" :key="i">
            <p @click="handleSelect(v)" :class="{ hover: activePath === v.routerName }" v-if="v.clientType.includes(userInfo.type || 'STUDENT') || !v.clientType.length">
              {{ v.name }}
              <ul v-if="(v.childrens || []).length">
                <li v-for="(v, i) in v.childrens" @click.stop="handleSelect(v)" :key="i">
                  {{ userInfo.type === "TEACHER" && v.teaName ? v.teaName : v.name }}
                </li>
              </ul>
            </p>
          </section>
        </template>
      </div>
      <div class="nav_operation">
        <!-- <el-button class="btn" type="primary">前往教师端</el-button>` -->
        <template v-if="userInfo.type === 'TEACHER' && userInfo.modules === '1'">
          <div class="message_img" v-if="['TEACHER_RESEARCH', 'STUDENT', 'TEACHER'].includes(userInfo.type)">
            <i v-if="userInfo.unreadNum>0"></i>
            <img style="cursor: pointer;" @click="messageChange" src="@/assets/images/home/small_bell.png" alt="" />
          </div>
        </template>

        <el-dropdown trigger="click" @command="commandHandler">
          <span class="el-dropdown-link flex_center">
            <img class="head_portrait" :src="userAvatarDict[userInfo.headPhoto || '00']" alt="" />
            <p :style="{ color: '#fff', fontSize: '18px' }">{{ userInfo.username }}</p>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="user">用户中心</el-dropdown-item>
            <el-dropdown-item command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </section>
  </div>
</template>

<script>
// import loginModal from "@/components/loginModal.vue";
import { mapState, mapMutations } from "vuex";
import publicUrl from "../../assets/js/interface";
import { menuList } from "./menus.json";
import { menuList1 } from "./menus-module-a.json";

// import { menuList } from "./menus_new.json";
import utils from "@/assets/js/utils.js";
export default {
  name: "cmp-header",
  props: {
    type: {
      type: Number,
      default: 2,
    },
  },
  data() {
    return {
      loadingCount: 0,
      screenWidth: window.innerWidth,
      menuList: menuList,
      menuList1: menuList1,
      activePath: "",
      headerStyles: {},
      isHeaderFixed: true,
      routerDict: {
        1: "home",
        "3-1": "onlinecourses",
        "3-2": "home",
        "3-3": "home",
        "3-4": "home",
        "3-5": "classmanagement",
        4: "fileresources",
        "5-1": "famousteacher",
        "5-2": "famousteacher",
      },
    };
  },
  components: {
    // loginModal,
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
      userAvatarDict: (state) => state.userAvatarDict,
    }),
  },
  created() {},
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll, true);
    window.removeEventListener("resize", this.handleScroll, true);
  },
  watch: {
    $route: {
      handler: function(to) {
        this.activePath = to.name;
        if (to.meta.parentUrl) this.activePath = to.meta.parentUrl;
        if (to.name === "home") {
          this.handleScroll();
          window.addEventListener("scroll", this.handleScroll, true);
          window.addEventListener("resize", this.handleScroll, true);
        } else {
          this.isHeaderFixed = true;
          this.headerStyles = {};
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapMutations(["setUserInfo"]),
    messageChange() { // 查看消息
      this.$router.push({
        name: 'messagePage'
      })
    },
    handleScroll() {
      if (this.$route.name !== "home") return;
      let scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
      let htmlHeight = document.documentElement.clientWidth || document.body.clientWidth;
      if (scrollTop >= 500) {
        this.isHeaderFixed = true;
        this.headerStyles = {};
      } else {
        this.isHeaderFixed = false;
        this.headerStyles = {
          height: htmlHeight >= 1200 ? "26vw" : "312px",
          // top: '-76px',
          // marginBottom: '-76px',
        };
      }
    },

    handleSelect(item) {
      if ((item.childrens || []).length) {
        // 有二级菜单的时候 一级菜单不能点击
        return false;
      }
      if (item.isLogin && !this.userInfo.token) {
        // 判断当前菜单是否需要登录
        this.$jstools.myEvent.dispatchEvent("login-open", { flag: true });
        return false;
      }
      console.log(this.userInfo)

      // if(item.routerName == 'onlinecourses'){
      //   this.$message.info('正在开发中');
      //   return false;
      // }
      if (item.routerName) {
        // 内部链接
        this.$router.push({
          name: item.routerName,
        });
        return false;
      }
      if (item.url) {
        // 外部链接
        // let iframeobj=document.createElement('iframe')
        // iframeobj.onload=function(){
        //   window.open(item.url);
        //   document.body.removeChild(iframeobj);
        // }
        // document.body.appendChild(iframeobj);
        if (item.paramsFlag) {
          let pwd=localStorage.getItem('accpwd');
          let dict = utils.jsonParse(pwd, {});
          if(dict[this.userInfo.account]){
            // window.open(item.url+'/login?directLogin=1&userName='+this.userInfo.account+'&password='+dict[this.userInfo.account])
            window.open(item.url+'login?directLogin=1&userName='+this.userInfo.account+'&password='+dict[this.userInfo.account])
          }else{
            window.open(item.url);
          }
        } else {
          window.open(item.url);
        }

        return false;
      }
    },
    commandHandler(command) {
      if (command === "logout") {
        this.$ajaxJson.post(publicUrl.logout).finally(() => {
          this.$root.$ajax.defaults.headers.token = "";
          this.$root.$ajaxJson.defaults.headers.token = "";
          this.setUserInfo();
          this.$router.push({ name: "login" });
          window.sessionStorage.removeItem('searchData')
        });
      } else {
        this.$router.push({ name: command });
      }
    },
  },
};
</script>

<style scoped lang="less">
@import "@/assets/styles/public.less";
.cmp_header {
  position: relative;
  width: 100%;
  height: 76px;
  border-bottom: 1px solid #fff;
  .flex_align_items;

  > section {
    .width_1200px;
  }
  .login_logo {
    width: 210px;
    height: 26px;
    display: block;
    position: absolute;
    top: 24px;
    left: 50px;
  }
  > section {
    display: flex;
    position: relative;
    .nav_list {
      display: flex;
      p {
        font-size: 16px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #333333;
        margin-right: 50px;
        cursor: pointer;
        padding: 14px 0;
        position: relative;
        &:hover {
          ul {
            display: block;
          }
        }
      }
      ul {
        position: absolute;
        width: 116px;
        left: 50%;
        top: 48px;
        transform: translateX(-50%);
        background: #fff;
        display: none;
        padding: 8px 0;
        border-radius: 6px;
        text-align: center;
        z-index: 999;
        box-shadow: 0px 6px 10px 0px rgba(0, 12, 100, 0.2);
        font-size: 16px;
        font-family: SourceHanSansCN-Light, SourceHanSansCN;
        font-weight: 300;
        color: #333333;
        li {
          padding: 8px 0;
          color: #333333;
          &:hover {
            cursor: pointer;
            background-color: #e5f6ff;
          }
        }
      }
      .hover {
        color: #00a7ff;
        position: relative;
        &::after {
          content: "";
          position: absolute;
          bottom: -6px;
          left: 50%;
          transform: translateX(-50%);
          width: 100%;
          height: 1px;
          box-shadow: 0px 3px 9px 0px rgba(183, 183, 183, 0.27);
          background: #00a7ff;
        }
      }
    }
    .nav_operation {
      position: absolute;
      height: 100%;
      display: flex;
      align-items: center;
      right: 0;
      .message_img {
        position: relative;
        i {
          position: absolute;
          width: 8px;
          height: 8px;
          background: #ff3535;
          border: 1px solid #ffffff;
          border-radius: 50%;
          right: 8px;
          top: -5px;
        }
      }
      .btn {
        width: 102px;
        height: 28px;
        background: #00a7ff;
        border-radius: 6px;
        .flex_center;
      }
      img {
        margin: 0 10px;
        height: 28px;
      }
      .head_portrait {
        width: 36px;
        height: 36px;
      }
    }
  }
}
.cmp_header_2 {
  background: #19a4ff;
  .nav_list {
    p {
      color: #fff !important;
      ul {
        color: #333333 !important;
      }
      &:hover {
        cursor: pointer;
      }
    }
    .hover {
      color: #fff !important;
      &::after {
        background: #fff !important;
      }
    }
  }
  .btn {
    background: #fff !important;
    color: #00a7ff;
  }
}
</style>
